import { init } from "@marko/runtime-tags/dom";
import "./index.marko";
import "../../src/routes/+layout.marko";
import "../../src/tags/app-header/index.marko";
import "../../src/tags/app-footer/index.marko";
import "../../src/tags/intro-section/index.marko";
import "../../src/tags/about-section/index.marko";
import "../../src/tags/project-carousel/index.marko";
import "../../src/tags/project-card/index.marko";
import "../../src/tags/contact-section/index.marko";
import "../../src/tags/app-header/index.marko";
import "../../src/tags/app-footer/index.marko";
import "../../src/tags/intro-section/index.marko";
import "../../src/tags/about-section/index.marko";
import "../../src/tags/project-carousel/index.marko";
import "../../src/tags/project-card/index.marko";
import "../../src/tags/contact-section/index.marko";
export default () => init();